module.exports = __webpack_public_path__ + "img/delete.cf16c1b8.svg";